// extracted by mini-css-extract-plugin
export default {"wrapper":"BlockOption_wrapper__Dj42h","title":"BlockOption_title__kjdC6"};